export const state = () => ({
    selectDesignatedMember: {},
    Result:'',
    editDesignatedMember:{},
})